// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 120) return "static/chunks/120-089e7bae0bc1c909.js";
	if (chunkId === 5849) return "static/chunks/5849-61ae90219f8bace0.js";
	if (chunkId === 8508) return "static/chunks/8508-fbbe65a78397ccc1.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"472":"424b289187625c19","1545":"0bc22c83e5d9fbb3","3425":"a07724f380c56d4a","3947":"f7c9abc90b75a1ef","5284":"bd3d1c69c418ead3","6222":"12331c6a73a48b85","7030":"ba6a454510cbcc81","7852":"84af407427a82790","9341":"b44eac88706e1513","9521":"60039d14f0221c37"}[chunkId] + ".js";
};